import HideHeaderButtons from 'src/javascripts/components/tables/checkboxes/HideHeaderButtons';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Bulk delete using selected record IDs from a table
export default function(tableId) {

  // On delete bulk
  $('.delete-bulk').off().on('click', function() {
    let url = $(this).data('url');
    let params = {};
    params['record_ids'] = $('#' + tableId).data('record-ids');
    $.ajax({
      type: 'DELETE',
      dataType: 'json',
      url: url + '?' + $.param(params),
      complete(result) {

        // Reload table
        $('#' + tableId).DataTable().ajax.reload();

        // Let user know was successful
        ToastCustom({title: 'Success', message: 'Successfully removed selected records', delay: 8000, autohide: true, type: 'success'});

        // Hide header buttons
        HideHeaderButtons(tableId);

      }

    });

  })

}